/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import S_D_CHAT from "./S_D_CHAT";
import S_D_GRAPH from "./S_D_GRAPH";
import S_D_HISTORY from "./S_D_HISTORY";
import S_D_TEXT_AREA from "./S_D_TEXT_AREA";
import SIDEBAR_LAYER from "../sidebar_map_right/SIDEBAR_LAYER";
import SIDEBAR_LAYER_EMPTY from "../sidebar_map_right/SIDEBAR_LAYER_EMPTY";
import ProgressBar from "../common_spinner/ProgressBar";
// import LayerList from "../viewer_bottom_bar/LayerList";

/*REDUX*/
import { set_value_sini_data } from "../../App/actions/sini_data_actions";
import { is_user_get_access_by_license_key } from "../../App/actions/filter_license";
import BLOCKED from "./BLOCKED";

import {
  get_layer_id_ai,
  push_layer_id_ai,
} from "../../App/actions/ai_preset_actions";
import dict from "../../Data/dict.json";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/

/*CONST*/

class SINI_DATA extends Component {
  state = {
    prevLayerIdActive: [],
  };
  componentDidMount() {
    this.props.get_layer_id_ai();
  }
  on_push_layer_id_ai = async () => {
    const layer_id = this.props.layer.layer_id;
    const layer_name = this.props.layer.layer_name;
    const body = { layer_id, layer_name };

    console.log(body);

    try {
      await this.props.push_layer_id_ai(body);
      this.props.get_layer_id_ai();
    } catch (error) {
      console.error("Error push_layer_id_ai:", error);
    }
  };
  on_set_menu_sidebar = (menu_sidebar) => {
    this.props.set_value_sini_data({
      key: "menu_sidebar",
      value: menu_sidebar,
    });
    localStorage.setItem("menu_sidebar", menu_sidebar);
  };

  on_change = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({ [name]: value });
  };

  render() {
    //local storage
    const language = localStorage?.language ? localStorage?.language : "ina";
    //local state

    //global props
    const menu_sidebar =
      localStorage?.menu_sidebar || this.props.sini_data_reducer.menu_sidebar;
    const { layer_id, layer_id_active } = this.props.layer;
    const { layer_id_ai, current_progress_demo } = this.props.ai_preset_reducer;
    const { loading_item_array } = this.props.loading_reducer;

    //content

    let sidebar_old;

    if (layer_id) {
      sidebar_old = (
        <SIDEBAR_LAYER geo_project_link={this.props.geo_project_link} />
      );
    } else {
      sidebar_old = <SIDEBAR_LAYER_EMPTY />;
    }

    const is_has_access_sini_ai =
      this.props.is_user_get_access_by_license_key("license_sini_ai");

    return (
      <main>
        <div className="menu_container_basic background_grey_light three_container margin_bottom">
          <button
            className={`button full_width ${
              menu_sidebar === "chat"
                ? "background_black text_white"
                : "background_grey_light"
            }`}
            onClick={() => this.on_set_menu_sidebar("chat")}
            title="Lihat dan kirim percakapan AI"
          >
            Chat
          </button>

          <button
            className={`button full_width ${
              menu_sidebar === "history"
                ? "background_black text_white"
                : "background_grey_light"
            }`}
            onClick={() => this.on_set_menu_sidebar("history")}
            title="Lihat riwayat interaksi dan hasil"
          >
            History
          </button>

          <button
            className={`button full_width ${
              menu_sidebar === "old_menu"
                ? "background_black text_white"
                : "background_grey_light"
            }`}
            onClick={() => this.on_set_menu_sidebar("old_menu")}
            data-mapid="clickSummary"
            title="Lihat ringkasan data (Summary)"
          >
            Summary
          </button>
        </div>

        {menu_sidebar === "chat" ? (
          <S_D_CHAT />
        ) : menu_sidebar === "graph" ? (
          <S_D_GRAPH />
        ) : menu_sidebar === "old_menu" ? (
          <>{sidebar_old}</>
        ) : (
          <S_D_HISTORY />
        )}
        {menu_sidebar !== "old_menu" && (
          <section
            style={{
              position: "absolute",
              bottom: "0px",
              left: 0,
              right: 0,
              paddingBottom: "10px",
              paddingTop: "6px",
              paddingLeft: "5px",
              paddingRight: "5px",
              backgroundColor: "rgba(199,206,214, 0.5)",
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
              boxSizing: "border-box",
              maxWidth: "100%",
              transform: "translateZ(0)",
            }}
          >
            {is_has_access_sini_ai?.is_pass ? (
              !layer_id ? (
                <div
                  style={{
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <p>{dict["Activate a Layer View"][language]}</p>
                </div>
              ) : !layer_id_ai.includes(layer_id) ? (
                <div
                  style={{
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {loading_item_array.includes("push_layer_id_ai") ? (
                    <ProgressBar
                      current_number={Number(current_progress_demo)}
                      total_number={100}
                      name="generate data resume"
                      is_hide_count={true}
                    />
                  ) : (
                    <span>
                      {" "}
                      {dict["No data resume has been generated yet."][language]}
                    </span>
                  )}

                  <button
                    className="button_big background_black text_white"
                    onClick={this.on_push_layer_id_ai}
                  >
                    {dict["Generate Data Resume"][language]}
                  </button>
                </div>
              ) : !layer_id_active.includes(layer_id) ? (
                <div
                  style={{
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <p>Aktifkan View</p>
                </div>
              ) : (
                <div>
                  {loading_item_array.includes("push_layer_id_ai") ? (
                    <ProgressBar
                      current_number={Number(current_progress_demo)}
                      total_number={100}
                      name="generate data resume"
                      is_hide_count={true}
                    />
                  ) : (
                    <>
                      <S_D_TEXT_AREA />
                      <button
                        className="button_big background_black text_white"
                        onClick={this.on_push_layer_id_ai}
                      >
                        Re-{dict["Generate Data Resume"][language]}
                      </button>
                    </>
                  )}
                </div>
              )
            ) : (
              <BLOCKED {...is_has_access_sini_ai} />
            )}
          </section>
        )}
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  layer: state.layer,
  project: state.project,
  properties: state.properties,
  loading_reducer: state.loading_reducer,
  sini_data_reducer: state.sini_data_reducer,
  license_reducer: state.license_reducer,
  ai_preset_reducer: state.ai_preset_reducer,
});

export default connect(mapStateToProps, {
  set_value_sini_data,
  is_user_get_access_by_license_key,
  push_layer_id_ai,
  get_layer_id_ai,
})(SINI_DATA);
